/* eslint-disable max-len */
const addSlide5 = (pptx, addBrandingToSlide) => {
  // presentation slide
  const slide5 = pptx.addSlide({ masterName: 'COMPANY_BRANDING' });
  slide5.addText('TEST DE POSITIONNEMENT', {
    x: 1.25,
    y: 0.25,
    w: 8,
    h: 0.5,
    align: 'center',

    // Style du texte
    fontSize: 22,
    color: '4f4f4f',
    bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'fae3f2' },

    // Bordure
    line: {
      color: 'f71616',
      width: 1,
    },
  });

  slide5.addText([
    { text: 'Le test vous permet d\'évaluer votre niveau d\'anglais.', options: { color: '696969' } },
    { text: '\nVos résultats seront affichés à la fin du test.', options: { color: '696969' } },
    { text: 'Vous pourrez ensuite accéder à un programme adapté à votre niveau.', options: { color: '696969' } },
  ], {
    x: 1.25,
    y: 1.25,
    w: 8,
    h: 1.1,
    align: 'center',

    // Style du texte
    fontSize: 16,
    color: '4f4f4f',
    // bold: true,

    // Style de la forme
    shape: pptx.ShapeType.rect,
    fill: { color: 'ffffff' },

    // Bordure
    line: {
      color: 'f71616',
      width: 1, // épaisseur de la bordure
    },
  });

  slide5.addText(
    [
      {
        text: 'Le test est composé de ',
        options: { color: '696969' },
      },
      {
        text: '60 questions',
        options: { bold: true, color: '696969' },
      },
      {
        text: ' et comprend des questions de :',
        options: { color: '696969', breakLine: true },
      },
      { text: 'Grammaire', options: { bullet: true, indentLevel: 1, color: '696969' } },
      { text: 'Vocabulaire', options: { bullet: true, indentLevel: 1, color: '696969' } },
      { text: 'Compréhension de textes', options: { bullet: true, indentLevel: 1, color: '696969' } },
      { text: 'Compréhension orale', options: { bullet: true, indentLevel: 1, color: '696969' } },
    ],
    {
      x: 1.25,
      y: 2.7,
      w: 8,
      h: 1.6,
      fontSize: 16,
      shape: pptx.ShapeType.rect,
      fill: { color: 'ffffff' },
      line: { color: 'f71616', width: 1 },
      // align: 'left',
    },
  );

  slide5.addText(
    [
      { text: 'Il est à réaliser en ', options: { color: '696969' } },
      { text: '50 minutes maximum', options: { bold: true, color: '696969' } },
      { text: ' et en ', options: { color: '696969' } },
      { text: 'une fois', options: { bold: true, /* italic: true, */ color: '696969' } },
      { text: '.\n', options: { color: '696969' } },
      { text: 'Utilisez ', options: { color: '696969' } },
      { text: 'casque ou écouteurs', options: { bold: true, color: '696969' } },
      { text: ' pour les exercices audios !', options: { color: '696969' } },
    ],
    {
      x: 1.25,
      y: 4.5,
      w: 8,
      h: 0.8,
      fontSize: 16,
      shape: pptx.ShapeType.rect,
      fill: { color: 'FFFFFF' },
      line: { color: 'FF0000', width: 1 },
      align: 'left',
    },
  );

  addBrandingToSlide(pptx, slide5);
};

export default addSlide5;
